// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"28":"f374dcdd439808c9f283","291":"cea4f6c73dcaa849bead","361":"fa5ef990c2cfcdaec48a","464":"fed381ee29c796bcbdac","523":"f0f73950c350833f2fcc","837":"64128748d9e8c83d9b83"}[chunkId] + ".chunk.js";
};